/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/views/help-document/index.vue'

const helpDocument = {
  path: '/help-document',
  component: Layout,
  name: 'HelpDocument',
  hidden: true,
  meta: {
    title: 'helpDocument',
    perm: 'siteHelpDocument'
  }

}
export default helpDocument
